module.exports = __webpack_public_path__ + "static/media/2021CNYtakeaway_promo.bcb66f38.jpg";